import { useMemo } from "react";

import { useWorldViewIfSeated } from "../neucleos/worldView";
import { useNeucleosWorldStore } from "../neucleos/worldStore";
import { resolvePaletteWorld, type PaletteWorld } from "./CommandPalette.logic";

/**
 * W-57ca754b: the World the search overlay (Cmd+K, Go to File, content
 * search) speaks for, from the person's selection; null is Local. Outside the
 * World view provider there is no World to speak for.
 */
export function usePaletteWorld(): PaletteWorld | null {
  const room = useWorldViewIfSeated()?.state ?? null;
  const worlds = useNeucleosWorldStore((state) => state.worlds);
  const activeWorldKey = useNeucleosWorldStore((state) => state.activeWorldKey);
  const localSelected = useNeucleosWorldStore((state) => state.selection?.status === "local");
  return useMemo(
    () =>
      room === null ? null : resolvePaletteWorld({ room, localSelected, activeWorldKey, worlds }),
    [activeWorldKey, localSelected, room, worlds],
  );
}
